<template>
  <div class="container">
    <pfx-admin-menu />
    <h2>PFX Admin</h2>
    <br/>
    <div v-if="loading"><InlineSpinner /></div>
    <div class="clearfix" v-else>
      <div class="col15">
        <img :src="photoUrl" width="150" class="user-avatar" />
      </div>
      <div class="col45">
        <div>Name: {{ profile.firstName }} {{ profile.lastName }}</div>
        <div>E-Mail: {{ profile.email }}</div>
        <div><small>User ID: {{ profile.id }}</small></div>
        <br/>
        <button class="btn-danger btn-small" @click="removeAdminDialog"><v-icon dark>block</v-icon> Remove as PFX admin</button>
      </div>
    </div>
    <br/>
    <router-link to="/pfxadmin/users">&lt; Back to admin list</router-link>
  </div>
</template>

<script>
  import PfxAdminMenu from './PfxAdminMenu.vue'
  import InlineSpinner from './elements/InlineSpinner.vue'
  import { mapMutations } from 'vuex'

  export default {
    name: 'PfxAdminViewUser',
    components: {
      PfxAdminMenu,
      InlineSpinner
    },
    data() {
      return {
        userId: this.$route.params.userId,
        loading: true,
        profile: {}
      }
    },
    computed: {
      photoUrl() {
        return this.profile.photoUrl || require('../assets/placeholder-user.png')
      }
    },
    created() {
      this.loadUser()
    },
    methods: {
      ...mapMutations([
        'setLoadingSpinner',
        'openDialog'
      ]),

      loadUser() {
        this.loading = 2

        this.$PfxBackendApi.getUser(this.userId).then(res => {
          console.log('getUser res', res)
          this.profile = res.data || {}
        }).catch(err => {
          console.error('getUser err', err)
          this.$notify({ type: 'danger', message: 'Unexpected error during loading user profile' })
          if (err.data.message) {
            this.$notify({ type: 'danger', message: err.data.message })
          }
        }).then(() => this.loading--)

        this.$PfxBackendApi.getPfxAdminUsers().then(res => {
          console.log('getPfxAdminUsers res', res)
          this.admins = res.data || []
        }).catch(err => {
          console.error('getPfxAdminUsers err', err)
          this.$notify({ type: 'danger', message: 'Unexpected error during loading admin users' })
          if (err.data.message) {
            this.$notify({ type: 'danger', message: err.data.message })
          }
        }).then(() => this.loading--)
      },

      removeAdminDialog() {
        this.$store.commit('openDialog', {
          text: 'Are you sure?',
          buttons: [
            { title: 'Cancel', class: 'btn-neutral' },
            {
              title: 'Remove PFX admin', class: 'btn-danger',
              handler: () => {
                this.$store.commit('closeDialog')
                this.removeAdmin()
              }
            }
          ]
        })
      },

      removeAdmin() {
        this.$PfxBackendApi.removePfxAdminUser(this.userId).then(res => {
          console.log('removePfxAdmin res', res)
          this.$notify({ type: 'info', message: 'PFX admin user removed' })
          this.$router.push('/pfxadmin/users')
        }).catch(err => {
          console.error('removePfxAdmin err', err)
          this.$notify({ type: 'danger', message: 'Unexpected error during removing admin user' })
        })
      }

    }
  }
</script>

<style lang="scss" scoped>
  @import 'node_modules/jeet/scss/index';

  .col15 { @include column(1/5); }
  .col45 { @include column(4/5); }
  .user-avatar { width: 100%; }

</style>



// WEBPACK FOOTER //
// src/components/PfxAdminViewUser.vue